import { wrapClientApiCall } from '../../../utils'

export const setInStorePayment = order_id => {
    return wrapClientApiCall({
        actionRoot: 'SET_INSTORE_PAYMENT',
        url: `api/set-locale-payment?order_id=${order_id}`,
        failurePayload: ({message}) => ({message}),
    })
}
